<div
  class="main-wrapper"
  [ngClass]="{
    'is-mobile': responsiveService.isMobilePortrait$ | async,
    'is-desktop': (responsiveService.isMobilePortrait$ | async) === false,
  }">
  <app-toolbar (sideMenuOpen)="toggleSideMenu()"></app-toolbar>
  <mat-sidenav-container class="sidenav-container" [autosize]="true">
    <mat-sidenav #sidenav mode="side" [opened]="sideMenuOpen" [disableClose]="true">
      <app-side-menu (closed)="sidenav.close()"></app-side-menu>
    </mat-sidenav>
    <mat-sidenav-content class="main-content">
      @if (isLoading$ | async) {
        <mat-spinner class="main-content__loading-spinner"></mat-spinner>
        <div class="main-content__loading-spinner-overlay"></div>
      }
      <div class="main-router-container">
        <router-outlet></router-outlet>
        @if (isZendeskEnabled) {
          @if (!isChatOpened()) {
            <div
              role="button"
              class="main-content__zendesk-launcher"
              matBadgePosition="above before"
              matBadgeColor="warn"
              [matBadge]="unreadMessagesCount() > 0 ? unreadMessagesCount() : ''"
              (click)="openZendeskChat()">
              <mat-icon class="main-content__zendesk-launcher-icon"> question_answer </mat-icon>
              {{ 'zendesk.info' | translate }}
            </div>
          } @else {
            <div role="button" class="main-content__zendesk-close" (click)="closeZendeskChat()">
              <mat-icon class="main-content__zendesk-launcher-icon"> close </mat-icon>
              {{ 'common.close' | translate }}
            </div>
          }
        }
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<a #downloadFileAnchor class="download-file-anchor"></a>
